import { connect } from 'react-redux';
import React from 'react';
import * as selectors from 'app/selectors';
import { FIX_LOCATION } from 'app/constants/hint';
import LocationRoleUsersForm from './LocationRoleUsersForm';

function LocationSettingInvoiceVerifyForm({
  updateLocation,
  users,
  checkUsers,
  confirmUsers,
  paidUsers
}) {
  return (
    <LocationRoleUsersForm
      updateLocation={updateLocation}
      users={users}
      fields={[
        {
          name: 'check_users',
          role: 'invoice_check',
          title: '核销人员',
          hint: FIX_LOCATION.paid_checker,
          selectedUsers: checkUsers,
          requiredMessage: '请选择至少一位核销人员'
        },
        {
          name: 'invoice_paid_checker',
          role: 'invoice_check_notify',
          title: '核销通知人员',
          hint: '可在核销完成后接收到通知信息的人员',
          selectedUsers: paidUsers,
          requiredMessage: '请选择至少一位接收核销通知的人员'
        },
        {
          name: 'confirm_users',
          role: 'invoice_confirm',
          title: '确认核销人员',
          hint: FIX_LOCATION.confirmed_checker,
          selectedUsers: confirmUsers,
          requiredMessage: '请选择至少一位确认核销人员'
        }
      ]}
    />
  );
}

function mapStateToProps(state, props) {
  const { loc_id } = props;
  return {
    users: selectors.getSpaceUsers(state),
    loc_id,
    checkUsers: selectors.getTeamRolesOfLocation(state, loc_id, 'invoice_check'),
    confirmUsers: selectors.getTeamRolesOfLocation(state, loc_id, 'invoice_confirm'),
    paidUsers: selectors.getTeamRolesOfLocation(
      state,
      loc_id,
      'invoice_check_notify'
    )
  };
}

export default connect(mapStateToProps)(LocationSettingInvoiceVerifyForm);
